var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tag',{staticStyle:{"width":"40px","height":"22px","padding":"0","text-align":"center"},attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.$t(`source_status.${_vm.status}`)))])
}
var staticRenderFns = []

export { render, staticRenderFns }